// extracted by mini-css-extract-plugin
export default {"primary":"CopyText_primary__GgoXD","copyTextLink":"CopyText_copyTextLink__oSVKN","copyText":"CopyText_copyText__nMhvD","actionIcon":"CopyText_actionIcon__NJ6HY"};